import React from 'react';
import { AdminPanelSettings, Description, LockOpen, ShieldOutlined } from '@mui/icons-material';
import { List } from '@mui/material';
import { LinkItem } from 'components/LinkItem/LinkItem';
import { SettingsListSubheader } from 'components/Settings/SettingsListSubheader';
import { useDeviceType } from 'contexts/ThemeContext/hooks/useDeviceType';
import { useTranslationContext } from 'contexts/TranslationContext/TranslationContext';
import { useGetSettingsQuery } from 'services/settingsService';

export const TermsAndAgreements = () => {
  const { isDesktop } = useDeviceType();
  const { translation } = useTranslationContext();
  const { data } = useGetSettingsQuery();
  const privacyPolicyUrl = data?.settings?.privacy_policy?.url;
  const eulaPolicyUrl = data?.settings?.eula_policy?.url;
  return (
    <List aria-labelledby="terms-and-agreements__settings-header">
      <SettingsListSubheader
        id="terms-and-agreements__settings-header"
        aria-label={translation('terms_and_agreements')}
        isDesktop={isDesktop}
      >
        {translation('terms_and_agreements')}
      </SettingsListSubheader>
      {privacyPolicyUrl && (
        <LinkItem
          textColor="primary"
          leftIcon={<ShieldOutlined color="secondary" />}
          href={privacyPolicyUrl}
          marginY={2}
        >
          {translation('privacy_policy')}
        </LinkItem>
      )}
      {eulaPolicyUrl && (
        <LinkItem
          textColor="primary"
          leftIcon={<AdminPanelSettings color="secondary" />}
          href={eulaPolicyUrl}
          marginY={2}
        >
          {translation('eula')}
        </LinkItem>
      )}
      <LinkItem
        textColor="primary"
        leftIcon={<Description color="secondary" />}
        href="https://www.wellframe.com/legalnotices/"
        marginY={2}
      >
        {translation('legal_notices')}
      </LinkItem>
    </List>
  );
};
